import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: "20px",
    minHeight: "calc(100vh - 191px)",
    display: "flex",
    flexDirection: "column"
  },
  gridContainer:{
    marginTop: "0.5em",
    justifyContent: "center",
  },
  gridItem:{
    minWidth: "25em",
  },
  tab: {
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    marginRight: "16px",
    padding: "0 !important",
  },
}));

export default useStyles;
